// extracted by mini-css-extract-plugin
module.exports = {"bold":"style__bold__xV5LJ","button":"style__button__Uiw8B","subNote":"style__subNote__5uawX"};